import IcoMoon from "@/components/IcoMoon";

export default function VehicleFitmentCheck({ fitIds, vehicle }) {
  const PositiveVehicle = () => {
    return (
      <div className="flex items-center">
        <IcoMoon className="mr-1" icon="icon-green-check" />
        <span className="text-xs font-bold text-green">
          Fits your {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
        </span>
      </div>
    );
  };

  const NegativeVehicle = () => {
    return (
      <div className="flex items-center">
        <IcoMoon className="mr-1" icon="icon-red-reject" path="2" fontSize="1.1" />
        <span className="text-xs font-bold text-red">
          Doesn&apos;t fit your {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
        </span>
      </div>
    );
  };

  const NoPresentVehicle = () => {
    return (
      <div className="flex items-center">
        <IcoMoon className="mr-1" icon="icon-warning" fontSize="1.1" path="2" />
        <span className="text-xs font-bold text-gold">This product is vehicle specific</span>
      </div>
    );
  };

  const renderFitmentCheck = () => {
    if (vehicle?.vehicleNumber && fitIds?.includes(vehicle.vehicleNumber)) {
      return <PositiveVehicle />;
    } else if (vehicle?.vehicleNumber && !fitIds?.includes(vehicle.vehicleNumber)) {
      return <NegativeVehicle />;
    } else {
      return <NoPresentVehicle />;
    }
  };

  return renderFitmentCheck();
}
